import mapboxgl from 'mapbox-gl';
import { colourScheme } from '../../../theme';
import MapHelpers from '../../map.utils';
import MapLayer from '../map-layer.enum';
import MapLayerManager from '../map-layer-manager.utils';
import MapLayerVisibility from '../map-layer-visibility.enum';

function addLineLayer(
  layer: MapLayer | string,
  paint: mapboxgl.LinePaint = {},
  groupLayerid?: string,
  drawingColour?: string
) {
  // biome-ignore lint/correctness/noUnusedInstantiation: fire-and-forget Promise used for its side effects
  new Promise((resolve) => {
    if (groupLayerid) {
      MapLayerManager.AddLayerinGroups(
        {
          id: layer,
          type: 'line',
          source: layer,
          layout: {
            visibility: MapLayerVisibility.NOT_VISIBLE,
          },
          paint: {
            ...paint,
            'line-color': drawingColour || colourScheme?.areaTint,
          },
        },
        [groupLayerid]
      );
    } else {
      MapHelpers.addLayer({
        id: layer,
        type: 'line',
        source: layer,
        layout: {
          visibility: MapLayerVisibility.NOT_VISIBLE,
        },
        paint: {
          ...paint,
          'line-color': drawingColour || colourScheme?.areaTint,
        },
      });
    }
    resolve(MapHelpers);
  });
}

export default addLineLayer;
